import { render, staticRenderFns } from "./rollBack.vue?vue&type=template&id=6b742b9e&scoped=true&"
import script from "./rollBack.vue?vue&type=script&lang=js&"
export * from "./rollBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b742b9e",
  null
  
)

export default component.exports